function updateInlineCartQuantity(count, attempts = 0) {
  const wrappers = document.querySelectorAll('.inline-cart-quantity');
  if (wrappers.length === 0 && attempts < 5) {
    requestAnimationFrame(() => updateInlineCartQuantity(count, attempts + 1));
    return;
  }

  wrappers.forEach(wrapper => {
    if (count < 10) {
      let img = wrapper.querySelector('.inline-cart-number');
      if (!img) {
        wrapper.innerHTML = '';
        img = document.createElement('img');
        img.classList.add('inline-cart-number', `inline-cart-num-${count}`);
        img.alt = `Cart quantity ${count}`;
        wrapper.appendChild(img);
      }
      const newSrc = `https://cdn.shopify.com/s/files/1/0020/8587/9872/files/cart_${count}.png?v=1747260788`;
      if (img.src !== newSrc) {
        img.style.visibility = 'hidden';
        img.src = newSrc;
        if (img.decode) {
          img.decode().then(() => { img.style.visibility = 'visible'; });
        } else {
          img.onload = () => { img.style.visibility = 'visible'; };
        }
      }
    } else {
      wrapper.innerHTML = `<span class="inline-cart-text">${count}</span>`;
    }
  });
}

function updateCarts() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(data => {
      const count = data.item_count;

      // --- Update header cart quantities ---
      document.querySelectorAll('.cart-quantity-wrapper').forEach(wrapper => {
        if (count < 10) {
          let img = wrapper.querySelector('.cart-quantity-image');
          if (!img) {
            wrapper.innerHTML = '';
            img = document.createElement('img');
            img.classList.add('cart-quantity-image', `cart-num-${count}`);
            img.alt = `Cart quantity ${count}`;
            wrapper.appendChild(img);
          }
          const newSrc = `https://cdn.shopify.com/s/files/1/0020/8587/9872/files/cart_${count}.png?v=1747260788`;
          if (img.src !== newSrc) {
            img.style.visibility = 'hidden';
            img.src = newSrc;
            (img.decode ? img.decode() : Promise.resolve()).then(() => {
              img.style.visibility = 'visible';
            });
          }
        } else {
          wrapper.innerHTML = `<span class="cart-count-text">${count}</span>`;
        }
      });

      // --- Update inline cart quantities (both desktop & mobile) ---
      updateInlineCartQuantity(count);

      // --- Show/hide inline carts correctly across devices ---
document.querySelectorAll('.inline-cart-wrapper.desktop-only, .inline-cart-wrapper.mobile-only').forEach(wrapper => {
  const isMobile = wrapper.classList.contains('mobile-only');

  if (count > 0) {
    wrapper.style.display = 'flex';
    wrapper.style.visibility = 'visible';
  } else if (isMobile) {
    // Keep mobile inline cart visible with 0 quantity
    wrapper.style.display = 'flex';
    wrapper.style.visibility = 'visible';

    const quantity = wrapper.querySelector('.inline-cart-quantity');
    if (quantity) {
      quantity.innerHTML = `
        <img
          src="https://cdn.shopify.com/s/files/1/0020/8587/9872/files/cart_0.png?v=1747260788"
          class="inline-cart-number inline-cart-num-0"
          alt="Cart quantity 0"
        >
      `;
    }
  } else {
    // Hide desktop inline cart when empty
    wrapper.style.display = 'none';
    wrapper.style.visibility = 'hidden';
  }
});

    });
}

// Ensure inline cart updates when drawer opens or closes
document.addEventListener('cart:updated', updateCarts);
document.body.addEventListener('open:cart', () => {
  setTimeout(updateCarts, 600);
});

// Watch for drawer close/removal (cart emptied)
const observer = new MutationObserver(() => {
  if (!document.querySelector('cart-drawer, .cart-drawer, #CartDrawer')) {
    updateCarts();
  }
});
observer.observe(document.body, { childList: true, subtree: true });

document.documentElement.classList.add('menu-loaded');

document.addEventListener('DOMContentLoaded', function () {
  updateCarts();
  document.addEventListener('cart:updated', updateCarts);
  document.body.addEventListener('click', function (e) {
    if (
      e.target.matches('form[action^="/cart/add"] [type="submit"], form[action^="/cart/add"] button, button[name="add"]') ||
      e.target.closest('[data-item-remove]')
    ) {
      setTimeout(updateCarts, 500);
    }
  });
});